<div class="data-table-container" id="data-table-container" [class.show-deviation]="showDeviation">
    <!-- Panle Layout -->
    <div class="tools-panel" *ngIf="false && !isChildrenTable && data.length > 0">
        <div class="left-panel">
            <div class="buttons-group">
                <button>
                    <img src="assets/images/download.svg">
                </button>
                <button>
                    <img src="assets/images/fullscreen.svg">
                </button>
            </div>
            <div *ngIf="isPagingEnabled" class="paging-panel">

                <button class="paging-button disabled" (click)="changePage('first')"
                    [class.disabled]="isPreviousDisabled" [disabled]="isPreviousDisabled">
                    <img src="assets/images/chevron-double-left.svg">
                </button>
                <button class="paging-button" (click)="changePage('previous')" [class.disabled]="isPreviousDisabled"
                    [disabled]="isPreviousDisabled">
                    <img src="assets/images/chevron-left.svg">
                </button>
                <div class="paging-text">
                    {{pagingDetails.start}} - {{pagingDetails.end}} of {{pagingDetails.total}}
                </div>
                <button class="paging-button" (click)="changePage('next')" [class.disabled]="isNextDisabled"
                    [disabled]="isNextDisabled">
                    <img src="assets/images/chevron-right.svg">
                </button>
                <button class="paging-button" (click)="changePage('last')" [class.disabled]="isNextDisabled"
                    [disabled]="isNextDisabled">
                    <img src="assets/images/chevron-double-right.svg">
                </button>
            </div>
        </div>
    </div>

    <!-- Table Layout -->
    <div class="table-wrapper" [class.one-column-table]="tableGroups.length == 1" (mouseup)="onMouseUp($event)">
        <div class="tabl-columns {{table.className}}" [class.disable-overflow]="isChildrenTable"
            *ngFor="let table of tableGroups;let tableIndx = index;">
            <table class="data-table-v2" [ngStyle]="{width:table.width}" [id]="'litmus-data-table-'+tableIndx">
                <thead class="data-table-header" *ngIf="!isChildrenTable && rows.length">
                    <tr class="data-table-row">
                        <th class="data-table-cell data-table-setting" *ngIf="table.isSettingsEnabled">
                            <img src="assets/images/settings.svg" (click)="openModal()" />
                        </th>
                        <th class="data-table-cell" [ngClass]="getDataCellClass(column.dataKey)"
                            [class.on-demand-trigger-cell]="column.source_type === 'on_demand_trigger'"
                            [class.active]="column.isColumnSorted"
                            [class.header-dropdown]="column.headerType == 'dropdown'"
                            *ngFor="let column of table.columns|  orderBy: 'order':'asc';let i = index;"
                            (mousemove)="onMouseMove($event)">
                            <div class="cell-wrapper"
                                [style.justifyContent]="column?.style?.headerAlign||column?.style?.headerTextAlign">
                                <app-ltms-dropdown *ngIf="column.headerType == 'dropdown'"
                                    [ngStyle]="{width:'calc(100% - 24px)'}" [selectedOption]="selectedFilter"
                                    [config]="column.dropdownConfig" [dropout]="true" [elementid]="column.dataKey"
                                    (onChange)="onChange($event)"></app-ltms-dropdown>
                                <img *ngIf="column.headerType == 'icon'" class="data-table-header-icon"
                                    [src]="column.icon" />
                                <div *ngIf="column.headerType == 'string' || !column.headerType"
                                [ngStyle]="{'text-align':(column?.style?.headerAlign == 'left'||column?.style?.headerTextAlign == 'left')?'left':''}"                                    class="data-table-header-label"
                                (mouseenter)="showCustomTooltip($event, getFullHeaderText(column))"
                                (mouseleave)="hideCustomTooltip()">{{column.header}}</div>
                                <img class="table-sort-icon" *ngIf="column.sortingEnabled && rows.length"
                                    [class.sorted]="!(column.sorted && column.isColumnSorted)" (click)="sort(column)"
                                    src="assets/images/arrow-up.svg" />
                            </div>
                            <!-- <div class="resizer" (mousedown)="onMouseDown($event,column)"
                                (mouseover)="onMouseOver(column)" (mouseout)="onMouseOut()"></div> -->
                        </th>
                    </tr>
                </thead>
                <colgroup>
                    <col *ngIf="table.isSettingsEnabled" />
                    <col *ngFor="let column of table.columns|  orderBy: 'order':'asc';let i = index;"
                        [ngClass]="getDataCellClass(column.dataKey)" [ngStyle]="{width: column?.style?.width}" />
                </colgroup>
                <tbody class="data-table-body" *ngIf="rows.length">
                    <ng-container *ngFor="let row of rows;let indx = index">
                        <tr class="data-table-row" [class.clickable-row]="isRowClickable"
                            [class.active-row]="row.isOnDemandLifecycleActive"
                            (click)="onRowClick($event,row)">
                            <td class="data-table-cell data-table-setting" *ngIf="table.isSettingsEnabled">
                                <img src="assets/images/settings.svg" style="opacity: 0;" />
                            </td>
                            <td class="data-table-cell" [ngClass]="getDataCellClass(column.dataKey)"
                            [class.on-demand-trigger-cell]="column.source_type === 'on_demand_trigger'"
                            [attr.title]="configs?.nativeTooltip === true ? row?.tooltip_text?.[column.dataKey] ?? row[column.dataKey] : null"
                            (mouseenter)="column.tooltipEnabled !== false &&
                            showCustomTooltip($event, row?.tooltip_text?.[column.dataKey] ?? row[column.dataKey] ?? '')"                                                         
                            (mouseleave)="hideCustomTooltip()"                                [class.active]="column.isColumnSorted"
                               

                                *ngFor="let column of table.columns|  orderBy: 'order':'asc';let i = index;"
                                [class.rating-type-badges]="column.raterType == 'badges'">
                                <div class="cell-wrapper" [class.child-cell-wrapper]="i == 0 && isChildrenTable"
                                    [class.active]="i != 0 && isChildrenTable">
                                    <div class="row-checkbox" (click)="toggleCheck($event,row)" *ngIf="i == 0 && isCheckBoxEnabled">
                                        <img class="filter-checkbox" *ngIf="row.selected"
                                            src="assets/images/checkbox-marked.svg">
                                        <img class="filter-checkbox" *ngIf="!row.selected"
                                            src="assets/images/checkbox-blank-outline.svg">
                                    </div>
                                    <div class="row-collapse-button" (click)="expandRow(column,row,indx)"
                                        *ngIf="isCollapsable && row.isChildExists && i == 0 && tableIndx == 0">
                                        <img [class.active]="row.isExpanded" src="assets/images/chevron-down.svg">
                                    </div>
                                    <div class="row-collapse-button" [style.background]="'transparent'"
                                        *ngIf="isChildrenTable">
                                        <img src="assets/images/chevron-down.svg">
                                    </div>
                                    <div class="content-wrapper"
                                        [class.opacity-0]="!isDataExistsForCoumn(row[column.dataKey])"
                                        [style.alignItems]="(column && column.style && column.style.cellTextAlign)?column.style.cellTextAlign:''"
                                        [style.justifyContent]="(column.componentType)?'center':''"
                                        [class.active]="i == 0 && isChildrenTable">
                                        <div class="data-type-component component-align-{{(column && column.style && column.style.cellTextAlign)?column.style.cellTextAlign:''}}"
                                            [class.padding-0]="column.sortingEnabled == false"
                                            *ngIf="isBadgesComponent(column)"
                                            [style.justifyContent]="column.style.cellAlign">
                                            <div class="rating-badges"
                                                [style.background]="getColor(column,row,column.dataKey)"
                                                *ngIf="column.componentType == 'badges' && column.dataType == 'number'">
                                                {{row[column.dataKey]}}
                                            </div>
                                            <div class="status-component"
                                                [style.background]="getColor(column,row,column.dataKey)"
                                                [style.color]="(getColor(column,row,column.dataKey))?'#FFFFFF':'#000000'"
                                                *ngIf="column.componentType == 'status' && column.dataType == 'string' ">
                                                {{row[column.dataKey]}}
                                            </div>
                                        </div>
                                        <div class="data-type-string" [class.padding-0]="column.sortingEnabled == false"
                                            [class.clickable]="column.clickable"
                                            [class.copy-enabled]="column.isCopyEnabled"
                                            [class.cell-value-with-deviation]="showDeviation && column.is_deviation_enabled"
                                            *ngIf="isDefaultType(column)"
                                            [style.color]="(column.style && column.style.color)?column.style.color : getColor(column,row,column.dataKey)"
                                            [style.font-weight]="column.style?.fontWeight"
                                            (click)="onSelectValue(column,row)"
                                            [style.textAlign]="(showDeviation && column.is_deviation_enabled) ? 'right' : (column.style.cellAlign||column.style.cellTextAlign)">
                                            {{row[column.dataKey]}}
                                            <i *ngIf="column.isCopyEnabled && row[column.dataKey] && row[column.dataKey] !== 'NA'"
                                                class="fa fa-copy cell-copy-icon"
                                                title="Copy"
                                                (click)="copyToClipboard(row[column.dataKey], $event)"></i>
                                            <span *ngIf="column.is_deviation_enabled && shouldShowDeviation(row.deviations?.[column.sortBy || column.dataKey])"
                                                class="data-table-deviation deviationSeperator"
                                                [title]="getDeviationTooltip(row.deviations[column.sortBy || column.dataKey])">
                                                {{row.deviations[column.sortBy || column.dataKey].deviation}}
                                                <i *ngIf="row.deviations[column.sortBy || column.dataKey].arrowType"
                                                    class="fa fa-caret-{{row.deviations[column.sortBy || column.dataKey].arrowType}}"></i>
                                            </span>
                                        </div>
                                        <div class="data-type-string" style="display: flex;"
                                            [class.padding-0]="column.sortingEnabled == false"
                                            *ngIf="isInfoType(column)"
                                            [style.color]="(column.style && column.style.color)?column.style.color : getColor(column,row,column.dataKey)"
                                            [style.font-weight]="column.style.fontWeight"
                                            [style.textAlign]="column.style.cellAlign||column.style.cellTextAlign">
                                            <div class="info-icon" *ngIf="row.info && row.info[column.dataKey]">
                                                <img src="assets/images/info-icon.svg"
                                                    [title]="row.info[column.dataKey]?row.info[column.dataKey]:''">
                                            </div>
                                            <span [class.clickable]="column.clickable"
                                                [style.font-weight]="column.style?.fontWeight"
                                                (click)="onSelectValue(column,row)">{{row[column.dataKey]}}</span>
                                        </div>
                                        <div class="data-type-string" [class.padding-0]="column.sortingEnabled == false"
                                            [style.textAlign]="column.style.cellAlign||column.style.cellTextAlign"
                                            *ngIf="isHtmlExists(column) && column['source_type'] != 'outbox' && column['source_type'] != 'on_demand_trigger' && column['source_type'] != 'delivery_status'"
                                            [style.color]="getColor(column,row,column.dataKey)"
                                            [innerHTML]="row[column.dataKey]">
                                        </div>
                                        <div class="data-type-string" [class.padding-0]="column.sortingEnabled == false"
                                            [style.textAlign]="column.style.cellAlign||column.style.cellTextAlign"
                                            *ngIf="isHtmlExists(column) && column['source_type'] == 'outbox'"
                                            [style.color]="getColor(column,row,column.dataKey)"
                                            (click)="alertRedirectURL(row[column.dataKey], $event)">
                                            <span class="linkText">Click Here</span>
                                        </div>
                                        <div class="data-type-string" [class.padding-0]="column.sortingEnabled == false"
                                            [style.textAlign]="column.style.cellAlign||column.style.cellTextAlign"
                                            *ngIf="isHtmlExists(column) && column['source_type'] == 'on_demand_trigger' && row[column.dataKey]">
                                            <button type="button" class="table-action-btn"
                                                [class.expired]="row.isOnDemandExpired"
                                                [disabled]="row.isOnDemandSending"
                                                (click)="onActionButtonClick(column, row, $event)">
                                                <span class="table-action-btn-loader" *ngIf="row.isOnDemandSending"></span>
                                                <span class="table-action-btn-label" *ngIf="!row.isOnDemandSending">
                                                    {{ row.isOnDemandExpired ? 'Expired' : (column.buttonLabel || row[column.dataKey] || 'Send') }}
                                                </span>
                                            </button>
                                        </div>
                                        <!-- Delivery Status -->
                                        <div class="delivery-status-wrapper" *ngIf="column.source_type === 'delivery_status'">
                                        
                                            <span class="delivery-channel" *ngFor="let item of row[column.dataKey]" [ngClass]="item.status"
                                                (mouseenter)="showCustomTooltip($event, item.tooltip)" (mouseleave)="hideCustomTooltip()">
                                        
                                                <i *ngIf="item.channel === 'phone'" class="fa fa-comment"></i>
                                        
                                                <i *ngIf="item.channel === 'email'" class="fa fa-envelope"></i>
                                        
                                                <i *ngIf="item.channel === 'whatsapp'" class="fa fa-whatsapp"></i>
                                        
                                                <i *ngIf="item.channel === 'link'" class="fa fa-link"></i>
                                        
                                            </span>
                                        </div>
                                        <div class="data-type-string ltms-col-ss"
                                            [class.padding-0]="column.sortingEnabled == false"
                                            [style.textAlign]="column.style.cellAlign||column.style.cellTextAlign"
                                            *ngIf="isTextEllipsisType(column)">
                                            <div class="data-text"
                                                [class.show-more]="(row.collapsableFields && row.collapsableFields[column.dataKey])">
                                                <div (click)="onSelectValue(column,row)"
                                                    *ngIf="!row[column.dataKey] || row[column.dataKey] == ''"
                                                    class="no-comments">
                                                    No comment provided
                                                </div>
                                                <div [id]="getEllpsisId(column,row)"
                                                    *ngIf="row[column.dataKey] && row[column.dataKey] != ''"
                                                    class="text-value {{'litmus-feed-'+row.interaction_status}}"
                                                    (click)="onSelectValue(column,row)"
                                                    [style.color]="getColor(column,row,column.dataKey)"
                                                    [class.ellipsis]="column.ellipsisEnabled">
                                                    {{row[column.dataKey]}}</div>
                                                <div class="expand-buttons"
                                                    *ngIf="isEllipsisActive(column,row) || (row.collapsableFields && row.collapsableFields[column.dataKey])"
                                                    (click)="toggleCollapseText($event,indx,row,column.dataKey)">
                                                    <span class="show-more-button">...more</span>
                                                    <span class="show-less-button">...less</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="description-wraper {{'litmus-feed-'+row.interaction_status}}"
                                            (click)="onSelectValue(column,row)"
                                            [class.padding-0]="column.sortingEnabled == false"
                                            [style.justifyContent]="column.style.cellAlign||column.style.cellTextAlign"
                                            *ngIf="column.descriptionFields && column.descriptionFields.length>0">
                                            <span class="description" *ngFor="let key of column.descriptionFields">
                                                <span class="description-value">{{row[key]}}</span>
                                                <span class="description-dot"></span>
                                            </span>
                                        </div>

                                        <div class="pii-description-wraper {{'litmus-feed-'+row.interaction_status}}" (click)="onSelectValue(column,row)"
                                            [class.padding-0]="column.sortingEnabled == false"
                                            [style.justifyContent]="column.style.cellAlign||column.style.cellTextAlign"
                                            *ngIf="column.piiDescriptionFields && column.piiDescriptionFields.length>0">

                                            <ng-container *ngFor="let key of column.piiDescriptionFields">
                                                <span class="description"
                                                    *ngIf="row[key] != null && row[key].toString().trim() !== '' && row[key].toString().trim().toLowerCase() !== 'na'"
                                                    (mouseenter)="showCustomTooltip($event, key + ': ' + row[key])"
                                                    (mouseleave)="hideCustomTooltip()">

                                                    <i *ngIf="key.toLowerCase().includes('mobile') || key.toLowerCase().includes('phone')"
                                                        class="fa fa-phone description-icon"></i>

                                                    <i *ngIf="key.toLowerCase().includes('whatsapp')"
                                                        class="fa fa-whatsapp description-icon whatsapp-icon"></i>

                                                    <i *ngIf="key.toLowerCase().includes('email')"
                                                        class="fa fa-envelope-o description-icon"></i>

                                                    <span class="description-value"
                                                        [class.pii-name]="key.toLowerCase().includes('name')">
                                                        {{row[key]}}
                                                    </span>

                                                    <i *ngIf="row[key] && !key.toLowerCase().includes('name')"
                                                        class="fa fa-copy description-copy"
                                                        title="Copy"
                                                        (click)="copyToClipboard(row[key], $event)">
                                                    </i>
                                                </span>
                                            </ng-container>
                                        </div>

                                        <div class="cohort-description-wraper {{'litmus-feed-'+row.interaction_status}}" (click)="onSelectValue(column,row)"
                                            [class.padding-0]="column.sortingEnabled == false"
                                            [style.justifyContent]="column.style.cellAlign||column.style.cellTextAlign"
                                            *ngIf="column.cohortDescriptionFields && column.cohortDescriptionFields.length>0">

                                            <ng-container *ngFor="let key of column.cohortDescriptionFields">
                                                <span class="description"
                                                    *ngIf="row[key] != null && row[key].toString().trim() !== '' && row[key].toString().trim().toLowerCase() !== 'na'"
                                                    (mouseenter)="showCustomTooltip($event, key + ': ' + row[key])"
                                                    (mouseleave)="hideCustomTooltip()">

                                                    <span class="description-value">{{row[key]}}</span>
                                                </span>
                                            </ng-container>
                                        </div>

                                        <!-- data icons -->
                                        <div (click)="onSelectValue(column,row)"
                                        *ngFor="let key of column.icons"
                                        [style.justifyContent]="column.style.cellAlign||column.style.cellTextAlign">
                                            <span class="description-value">{{row[key]}}</span>
                                            <span class="description-dot"></span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr class="collapse-row" [class.expand]="row.isExpanded"
                            *ngIf="row.children && row.children.length">
                            <td [attr.colspan]="(table.isSettingsEnabled)?table.columns.length+1:table.columns.length">
                                <app-ltms-data-table-v2 [configs]="childConfigs" [columns]="table.columns"
                                    [data]="row.children"></app-ltms-data-table-v2>
                            </td>
                        </tr>
                    </ng-container>
                    <ng-container *ngIf="emptyRows && emptyRows.length">
                        <tr *ngFor="let row of emptyRows;">
                            <td [attr.colspan]="(table.isSettingsEnabled)?table.columns.length+1:table.columns.length"
                                class="empty-row-cell">
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
                <tbody class="data-table-body" *ngIf="!rows.length">
                    <tr class="data-table-row">
                        <td [attr.colspan]="(table.isSettingsEnabled)?(table.columns.length+1):table.columns.length">
                            <app-ltms-error [code]="errorCode"></app-ltms-error>
                        </td>
                    </tr>
                </tbody>
                <tfoot class="data-table-footer" *ngIf="isFooterEnabled && !isChildrenTable">
                    <tr class="data-table-row">
                        <td class="data-table-cell data-table-setting" *ngIf="table.isSettingsEnabled"> </td>
                        <td class="data-table-cell" [ngClass]="getDataCellClass(column.dataKey)"
                            [class.on-demand-trigger-cell]="column.source_type === 'on_demand_trigger'"
                            [class.active]="column.isColumnSorted"
                            *ngFor="let column of table.columns|  orderBy: 'order':'asc';let i = index;"
                            [ngStyle]="{'color':'#3777FF'}">
                                <div class="cell-wrapper"
                                [class.opacity-0]="!isDataExistsForCoumn(footerData[column.dataKey])"
                                [class.cell-value-with-deviation]="showDeviation && column.is_deviation_enabled"
                                [style.justifyContent]="column.style.cellAlign">
                                {{footerData[column.dataKey]}}
                                <span *ngIf="column.is_deviation_enabled && shouldShowDeviation(footerData.deviations?.[column.sortBy || column.dataKey])"
                                    class="data-table-deviation deviationSeperator"
                                    [title]="getDeviationTooltip(footerData.deviations[column.sortBy || column.dataKey])">
                                    {{footerData.deviations[column.sortBy || column.dataKey].deviation}}
                                    <i *ngIf="footerData.deviations[column.sortBy || column.dataKey].arrowType"
                                        class="fa fa-caret-{{footerData.deviations[column.sortBy || column.dataKey].arrowType}}"></i>
                                </span>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <!-- Setting Layout -->
    <div class="field-selector" [class.show]="isModalOpen">
        <div class="field-container">
            <div class="field-selector-header">
                list View Setttings
            </div>
            <div class="field-selector-body">
                <label class="checkbox-container" *ngFor="let column of columnsSettings"
                    [class.active]="column.enabled">
                    <input type="checkbox" [checked]="column.enabled" (click)="setColumnsVisiblity(column)" />
                    <div class="checkobx">
                        <span class="checkmark"></span>
                    </div>
                    <div class="checkobx-text">{{column.header}}</div>
                </label>
            </div>
            <div class="field-selector-footer">
                <div class="left-panel">
                    <div class="actions" (click)="setDefaultValue()">Default</div>
                </div>
                <div class="mid-panel">
                    <button class="actions-apply-btns" [class.disabled]="!enableApplyButton"
                        [disabled]="!enableApplyButton" (click)="applyColumnSetting()">
                        Apply
                    </button>
                    <button class="actions-cancel-btns" (click)="closeModal()">
                        Cancel
                    </button>
                </div>
                <div class="right-panel">
                    <div class="actions" (click)="selectAllField()">Select all</div>
                    <div class="actions" (click)="deselectAllField()">Select none</div>
                </div>
            </div>
        </div>
    </div>
    <!-- Confirmation modal for URL redirection -->
    <div *ngIf="showConfirmationBox">
        <div class="modal modal-dialog-centered" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body confirmation-body">
                        <div><span class="alert-header">{{ "ALERT" | translate}}</span></div>
                        <div>
                            <p>{{ confirmationMessageKey | translate}}</p>
                        </div>
                        <div style="float: right; margin-top: 20px;">
                            <button type="button" class="btn btn-cancel btn-custom-cancel"
                                (click)="closeRedirectURLModal()">
                                {{ "DONT_CONTINUE" | translate }}
                            </button>
                            <button type="button" class="btn btn-default btn-custom-apply alert-ltms-btn" (click)="confirmModalProceed()">
                                {{ "YES_CONTINUE" | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>